import { Box } from "@mui/material"
import NarrowcastingView from "../narrowcastingView"

export default function Fullscreen() {
    return(
        <Box sx={{backgroundColor: 'black', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', overflow: 'hidden'}}>
            <NarrowcastingView screen={0}/>
        </Box>
    )
}